import { Typography, Card, Box, useTheme } from "@mui/material"

import { useTranslation } from "providers/i18n"
import { Carousel, CarouselItem } from "components/Carousel"
import { PostMediaCard } from "../../post"

export const NextopiaDetail = ({
  loading,
  highlights,
  description,
  onHighlightClick,
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const {
    root,
    section,
    sectionTitle,
    descriptionText,
    highlightCarousel,
    highlightCarouselItem,
    highlightCard,
  } = theme.components[`NextopiaDetail`]?.styleOverrides || {}

  const hasHighlights = Array.isArray(highlights) && highlights.length > 0

  if (loading) return null

  return (
    <>
      <Card sx={root}>
        {description && (
          <Box sx={section}>
            <Typography variant="body2" sx={descriptionText}>
              {t(description)}
            </Typography>
          </Box>
        )}
        {hasHighlights && (
          <Box sx={section}>
            <Typography component="h2" sx={sectionTitle}>
              {t("Highlight")}
            </Typography>
            <Carousel
              sx={highlightCarousel}
              options={{
                fixedWidth: "84px",
                fixedHeight: "152px",
                perPage: 2,
                gap: 8,
                padding: { left: 20, right: 20 },
              }}
            >
              {highlights?.map((data) => (
                <CarouselItem
                  key={`highlight-${data?.id}`}
                  sx={highlightCarouselItem}
                >
                  <PostMediaCard
                    sx={highlightCard}
                    key={`highlight-nextopia-${data?.id}`}
                    data={data}
                    onClick={onHighlightClick}
                  />
                </CarouselItem>
              ))}
            </Carousel>
          </Box>
        )}
      </Card>
    </>
  )
}
